<template lang="pug"> 
  v-row(no-gutters)
    v-col.px-1(cols=12, md=6)
      v-card.mt-3.pa-2(flat)
        v-list-item
          v-list-item-avatar
            v-img(
              :src="require('@/assets/anything/money-transfer.svg')"
            )
          v-list-item-content
            v-list-item-title {{ $t('transfer-money') }}
            .red--text(v-if='bankerrorMessages!==undefined') {{ bankerrorMessages }}
        v-divider
        v-row(v-if='hadData')
          v-col(
            v-for='(item,i) in bankList'
            :key='i'
            cols=12
            xs=6
            sm=6
            md=6
            lg=6
            align="center"
          )
            v-btn-toggle(
              v-model='bankSelected'
              color='blue' 
              style="width:100%;"
            )
              v-btn(
                :class="\
                item.amount_limit && item.amount_limit.amount_remain<selectAmount? \
                'blurColor' : ''"
                :value='item' 
                text
                block
                style="padding:1px;"
                @click="GA('SelectBank',item.bank_type.name)"
              )
                //- :disabled='(item.amount_limit && item.amount_limit.amount_remain<selectAmount) || !isBankMetCondition(item)'
                v-list-item
                  v-list-item-avatar(style="margin-right:2px;")
                    v-img( 
                      max-width="24"
                      max-height="24"
                      :src='bankIconPath(item.bank_type.id)'
                    )
                  v-list-item-content(style="width:100px;")  
                    div.d-flex.f-col.f-start
                      span {{ item.bank_type.name }} {{ item.is_upload_slip ? '(แนบสลิป)' : '' }}
                      span(v-if="!isBankMetCondition(item)").red--text.subtitle {{ bankSubtitle(item) }}
        v-card-actions
          v-card.d-flex.justify-center(
            v-if='bankerrorMessages!==undefined'
            tile 
            width='100%'
            dark
            class="btn-bank"
          ) {{ bankerrorMessages }}
    v-col.mt-3.px-1
      v-card.py-2(
        v-if="isNormalChannel && bankSelected && !bankSelected.is_upload_slip"
        flat
      )
        .mx-3.mb-2
          v-row(align="center")
            v-col  {{ $t('fill-money') }}
            v-col(cols=12 sm="auto" align="end") 
        v-divider
        .ma-3
          v-row(
            no-gutters 
            justify="center"
          )
            v-col(
              v-for='item in selectTabAmount'
              :key='item'
              cols="3"
              align="center"
            )
              v-btn-toggle(
                v-model='selectAmount'
                color="var(--bg-secondary-color)"
              )
                v-btn.ma-3.force-round( 
                  :value='item'
                  :disabled="!!selectedVoucher && canDisbleInput"
                  @click="GA ('SelectAmount', item)"
                ) {{ item }}
          v-form(@submit.prevent)
            h4 {{ $t('fill-amount') }}
            n-number-field-specific(
              v-model='selectAmount'
              class="input-fill-amount"
              :error-messages='amounterrorMessage'
              :placeholder="$t('placeholder.fill-amount')"
              :suffix="$t('unit.baht')"
              :disabled="!!selectedVoucher && canDisbleInput"
              :allow-decimal="Number(bankSelected && bankSelected.amount_type) !== 2"
            )
            v-btn(
              block
              dark
              depressed
              type='submit'
              :loading='submitStatus || onSubmitLoading'
              :disabled='submitStatus'
              color='var(--bg-secondary-color)'
              @click='nextPage ()'
            ) {{ isCreateQrCode ? $t('button.create-qr-code') : $t('button.deposit') }}

        //- ย้ายไปแสดงใน dialog กรุณาอ่านเกี่ยวกับการฝาก (deposit-info-dialog) ด้านล่าง
        //- v-col(v-if="isMattpay" cols=12 sm=12).mt-2
            v-card.auto-info
              div.text-info
                | ⚠️ ต้องโอนเงินจากบัญชีที่ใช้สมัครสมาชิกเท่านั้น
              div.text-info.mt-1
                | 📌 หากโอนเงินจากบัญชีอื่น ระบบจะไม่สามารถเติมเครดิตได้ และทางบริษัทจะดำเนินการโอนเงินคืนกลับไปยังบัญชีต้นทางเท่านั้น

        //- v-col(v-if="isNexvo || isNexvo2" cols=12 sm=12).mt-2
            v-card.auto-info
              div.text-info
                | 🚨 สำคัญ! สำหรับผู้ใช้งานธนาคาร
              div.mt-2
                div.bank-logo-list
                  div.bank-logo-item
                    img(src='@/assets/logo/ktb.png' width="30" class="mr-1")
                    | กรุงไทย
                  div.bank-logo-item
                    img(src='@/assets/logo/gsb.png' width="30" class="mr-1")
                    | ออมสิน
                  div.bank-logo-item
                    img(src='@/assets/logo/bbl.png' width="30" class="mr-1")
                    | กรุงเทพ
              div.mt-2.info-description
                | บางรายการอาจไม่มี Slip (สลิป) หรือ QR Code (คิวอาร์โค้ด) สำหรับอัปโหลด หรือชื่อผู้โอนแสดงเป็นภาษาอังกฤษ ทำให้ระบบไม่สามารถเติมเครดิตอัตโนมัติได้
              div.mt-2
                | ⚠️ กรุณาโอนจากบัญชีธนาคารที่ใช้สมัครสมาชิกเข้ามาเท่านั้น
              div.mt-2
                | ❗ หากฝากเงินแล้วเครดิตไม่เข้า กรุณาแจ้งแอดมินพร้อมหลักฐานการโอน เพื่อตรวจสอบและเติมยอดให้
              div.mt-2
                | 🙏🏻 ขออภัยในความไม่สะดวก

        //- v-col(v-if="isLinkDeepCode" cols=12 sm=12).mt-5
            v-card.auto-info
              div.info-title
                | 🚨 สำคัญ! ฝากผ่าน LINKDEEPCODE
              div.mt-2
                div 🔸 เป็นระบบฝากแบบ P2P
                div กรุณาโอนเงิน ให้ตรงยอดที่สร้างเท่านั้น
              div.mt-2
                div ❌ ห้ามโอนขาด
                div ❌ ห้ามโอนเกิน
                div ❌ ห้ามโอนซ้ำ
              div.mt-2
                div 🏦 ต้องโอนจากบัญชีธนาคารที่สมัครสมาชิกเท่านั้น
                div ❌ ห้ามใช้บัญชีบุคคลอื่นโอนเข้ามา
              div.mt-2
                | ⚠️ หากยอดโอนไม่ตรง หรือใช้บัญชีอื่นโอน ระบบจะไม่สามารถเติมเครดิตอัตโนมัติได้
              div.red-info.mt-2
                | ‼️ กรณีโอนเงินเกิน ลูกค้าต้องติดต่อบัญชีปลายทางด้วยตนเอง ทางบริษัทไม่สามารถดึงยอดส่วนต่างกลับได้
              div.mt-2
                | 🙏 กรุณาตรวจสอบยอดและบัญชีก่อนโอนทุกครั้ง

        v-divider.mt-3

        .mx-3
          v-row(align="center")
            v-col
            v-col(cols=12 sm="auto" align="end") 
              v-btn(
                block
                depressed
                :ripple="false"
                @click="goToLineAgent"
              )
                .mr-1 {{ $t('button.report-problem-topup-line') }}
                v-img(
                  max-width="25"
                  :src="require('@/assets/socials/line.svg')"
                )

      v-card(
        v-if="isTrueWalletChannel && bankSelected && !bankSelected.is_upload_slip"
        flat
      ).py-2
        v-row(no-gutters justify="", align="center").px-4.py-2
          v-col(cols=12 sm=6)
            v-list-item.bank-item
              v-avatar.mt-2.mr-5
                v-img(:src='bankIconPath(bankSelected.bank_type.id)')
              v-list-item-content {{ $t('destination-name') }} 
                b {{ bankSelected.name }}
              
                br
                | {{ $t('phone') }}
                .blue--text {{ bankSelected.number }}
                br                
          v-col(v-if="bankSelected.qr_image_url" cols=12 sm=6).qr-img.mt-2
            div.my-3(v-if="!!selectedVoucher && canDisbleInput" align="center")
              | {{ $t('placeholder.amount') }} 
              b {{ this.selectedVoucher.rules.topup_amount | currency }}
            div.onetime-title {{ $t('hint.deposit-one-time') }}
            v-img(:src='bankSelected.qr_image_url')
            div.onetime-title {{ $t('hint.deposit-one-time') }}

        v-divider.mt-3

        .mx-3
          v-row(align="center")
            v-col
            v-col(cols=12 sm="auto" align="end") 
              v-btn(
                block
                depressed
                :ripple="false"
                @click="goToLineAgent"
              )
                .mr-1 {{ $t('button.report-problem-topup-line') }}
                v-img(
                  max-width="25"
                  :src="require('@/assets/socials/line.svg')"
                )

      v-card(
        v-if="isScbChannel && bankSelected && !bankSelected.is_upload_slip"
        flat
      ).py-2
        v-row(no-gutters justify="", align="center").px-4.py-2
          v-col(cols=12 sm=12)
            v-list-item.bank-item.mt-2
              v-avatar.mt-2.mr-5
                v-img(:src='bankIconPath(bankSelected.bank_type.id)')
              v-list-item-content
                div.text-info {{ bankSelected.bank_type.name }} 
                b.mt-1 {{ bankSelected.number }}
                div.text-info {{ bankSelected.name }} 
                br

          v-col(cols=12 sm=12)              
            v-btn(
              block
              dark
              depressed
              color='var(--bg-secondary-color)'
              @click='copyText(bankSelected.number)'
            ) {{ $t('button.copy') }}


          //- ย้ายไปแสดงใน dialog กรุณาอ่านเกี่ยวกับการฝาก (deposit-info-dialog) ด้านล่าง
          //- v-col(cols=12 sm=12).mt-5
            v-card.auto-info
              div.info-title
                | ❗กรุณาอ่านก่อนทำรายการเติมเงิน❗
              div.mt-2
                ol
                  li กรุณาใช้บัญชีธนาคารที่ ผูกไว้กับระบบเท่านั้น
                  li เพื่อความรวดเร็วในการตรวจสอบยอด ควรโอนยอดที่ไม่ซ้ำกับครั้งก่อน
                  li หลังจากโอน ระบบจะทำการปรับเครดิต ให้อัตโนมัติภายใน 1นาที
                  li หากเครดิตไม่เข้าหรือพบปัญหา กรุณา ติดต่อเจ้าหน้าที่ทันที
                  li ในกรณีฝากแบบ อัพโหลดสลิป กรุณาอัพโหลดสลิปภายใน 10 นาทีเท่านั้น
              div.red-info.mt-2
                | 🔴 หลีกเลี่ยงการโอนเงินในช่วงเวลา 00:00 น. (เที่ยงคืน) เนื่องจากระบบธนาคารบางแห่งอาจไม่สามารถตรวจสอบยอดได้ในช่วงเวลาดังกล่าว 🔴

        v-divider.mt-3

        .mx-3
          v-row(align="center")
            v-col
            v-col(cols=12 sm="auto" align="end") 
              v-btn(
                block
                depressed
                :ripple="false"
                @click="goToLineAgent"
              )
                .mr-1 {{ $t('button.report-problem-topup-line') }}
                v-img(
                  max-width="25"
                  :src="require('@/assets/socials/line.svg')"
                )

      v-card(
        v-if="bankSelected && bankSelected.is_upload_slip"
        flat
      ).py-2
        v-row(no-gutters justify="", align="center").px-4.py-2
          v-col(cols=12 sm=12)
            v-list-item.bank-item.mt-2
              v-avatar.mt-2.mr-5
                v-img(:src='bankIconPath(bankSelected.bank_type.id)')
              v-list-item-content.gray-400--text 
                div.text-info {{ bankSelected.bank_type.name }} 
                b.mt-1 {{ bankSelected.number }}
                div.text-info {{ bankSelected.name }} 
                br

          v-col(cols=12 sm=12)              
            v-btn(
              block
              dark
              depressed
              color='var(--bg-secondary-color)'
              @click='copyText(bankSelected.number)'
            ).btn-rounded 
              span.ml-1
               | {{ $t('button.copy') }}เลขบัญชี

          v-col(cols=12 sm=12)  
            v-card.my-2(
              class="pa-4 text-center rainbow-box" 
              outlined 
              style="cursor:pointer" 
              @click="$refs.file.click()"
            )
              input(ref="file" type="file" accept="image/*" style="display:none" @change="onFileChange")

              template(v-if="!preview")
                v-img(src="@/assets/qr-placeholder.png" max-width="80" max-height="100" contain class="mx-auto")
                div.mt-2.grey--text กรุณาอัปโหลดรูปภาพสลิปโอนเงิน

              template(v-else)
                v-img(:src="preview" max-width="300" contain class="mx-auto")

            div.red--text.mt-2(v-if="errorMessage")
              | {{ errorMessage }}

            v-btn(
              block
              dark
              depressed
              type='submit'
              :loading='submitStatus || onSubmitLoading'
              :disabled='submitStatus'
              color='var(--bg-secondary-color)'
              @click='submitQr()'
            ).btn-rounded ยืนยันสลิปโอนเงิน

            canvas(ref="canvas" style="display: none;")

          v-col(cols=12 sm=12).mt-5              
            v-btn(
              block
              dark
              depressed
              color='#218E00'
              @click="goToLineAgent"
            ).btn-rounded
              .mr-1 
              span.ml-1
                | {{ $t('button.report-problem-topup-line') }}


          //- ย้ายไปแสดงใน dialog กรุณาอ่านเกี่ยวกับการฝาก (deposit-info-dialog) ด้านล่าง
          //- v-col(cols=12 sm=12).mt-2
            v-card.auto-info
              div.text-info.mt-1
                | 🚨 สำคัญ! สำหรับผู้ใช้งานธนาคาร
              div.mt-2
                div.bank-logo-list
                  div.bank-logo-item
                    img(src='@/assets/logo/ktb.png' width="30" class="mr-1")
                    | กรุงไทย
                  div.bank-logo-item
                    img(src='@/assets/logo/gsb.png' width="30" class="mr-1")
                    | ออมสิน
                  div.bank-logo-item
                    img(src='@/assets/logo/bbl.png' width="30" class="mr-1")
                    | กรุงเทพ
              div.mt-2.info-description
                | บางรายการอาจไม่มี Slip (สลิป) หรือ QR Code (คิวอาร์โค้ด) สำหรับอัปโหลด หรือชื่อผู้โอนแสดงเป็นภาษาอังกฤษ ทำให้ระบบไม่สามารถเติมเครดิตอัตโนมัติได้
              div.mt-2
                | ⚠️ กรุณาโอนจากบัญชีธนาคารที่ใช้สมัครสมาชิกเข้ามาเท่านั้น
              div.mt-2
                | ❗ หากฝากเงินแล้วเครดิตไม่เข้า กรุณาแจ้งแอดมินพร้อมหลักฐานการโอน เพื่อตรวจสอบและเติมยอดให้ 
              div.mt-2
                | 🙏🏻 ขออภัยในความไม่สะดวก
        //- v-divider.mt-3
          
       
  
    loading-status(:had-data='hadData')

    v-dialog(
      v-model='infoDialog'
      persistent
      scrollable
      max-width='600'
    )
      v-card
        v-card-text.pt-2
          v-card.auto-info(v-if="isMattpay && !isUploadSlip")
            div.text-info
              | ⚠️ ต้องโอนเงินจากบัญชีที่ใช้สมัครสมาชิกเท่านั้น
            div.text-info.mt-1
              | 📌 หากโอนเงินจากบัญชีอื่น ระบบจะไม่สามารถเติมเครดิตได้ และทางบริษัทจะดำเนินการโอนเงินคืนกลับไปยังบัญชีต้นทางเท่านั้น

          v-card.auto-info(v-if="((isNexvo || isNexvo2) && !isUploadSlip) || isUploadSlip").mt-4
            div.text-info
              | 🚨 สำคัญ! สำหรับผู้ใช้งานธนาคาร
            div.mt-2
              div.bank-logo-list
                div.bank-logo-item
                  img(src='@/assets/logo/ktb.png' width="30" class="mr-1")
                  | กรุงไทย
                div.bank-logo-item
                  img(src='@/assets/logo/gsb.png' width="30" class="mr-1")
                  | ออมสิน
                div.bank-logo-item
                  img(src='@/assets/logo/bbl.png' width="30" class="mr-1")
                  | กรุงเทพ
            div.mt-2.info-description
              span.red-info บางรายการอาจไม่มี Slip (สลิป) หรือ QR Code (คิวอาร์โค้ด) สำหรับอัปโหลด
              |  หรือชื่อผู้โอนแสดงเป็นภาษาอังกฤษ ทำให้ระบบไม่สามารถเติมเครดิตอัตโนมัติได้
            div.mt-2
              | ⚠️ กรุณาโอนจากบัญชีธนาคารที่ใช้สมัครสมาชิกเข้ามาเท่านั้น
            div.mt-2
              | ❗ หากฝากเงินแล้วเครดิตไม่เข้า กรุณาแจ้งแอดมินพร้อมหลักฐานการโอน เพื่อตรวจสอบและเติมยอดให้
            div.mt-2
              | 🙏🏻 ขออภัยในความไม่สะดวก

          v-card.auto-info.mt-3(v-if="isLinkDeepCode && !isUploadSlip")
            div.info-title
              | 🚨 สำคัญ! ฝากผ่าน LINKDEEPCODE 🚨
            div.mt-2
              div 🔸 เป็นระบบฝากแบบ P2P
              div กรุณาโอนเงิน ให้ตรงยอดที่สร้างเท่านั้น
            div.mt-2
              div ❌ ห้ามโอนขาด
              div ❌ ห้ามโอนเกิน
              div ❌ ห้ามโอนซ้ำ
            div.mt-2
              div 🏦 ต้องโอนจากบัญชีธนาคารที่สมัครสมาชิกเท่านั้น
              div ❌ ห้ามใช้บัญชีบุคคลอื่นโอนเข้ามา
            div.mt-2
              | ⚠️ หากยอดโอนไม่ตรง หรือใช้บัญชีอื่นโอน ระบบจะไม่สามารถเติมเครดิตอัตโนมัติได้
            div.red-info.mt-2
              div ‼️กรณีโอนเงินเกิน ลูกค้าต้องติดต่อบัญชีปลายทางด้วยตนเอง ทางบริษัทไม่สามารถดึงยอดส่วนต่างกลับได้ ‼️
              div ‼️กรณียกเลิกรายการแล้วสร้างรายการฝากใหม่ ต้องโอนยอดที่สร้างใหม่เท่านั้น ‼️
              div ‼️หลังจากโอนเงินแล้ว ห้ามกดยกเลิกโดยเด็ดขาด และต้องแนปสลิปทันทีหลังจากโอนเงินภายใน 10 นาทีเท่านั้น ‼️
            div.mt-2
              | 🙏 กรุณาตรวจสอบยอดและบัญชีก่อนโอนทุกครั้ง

          v-card.auto-info.mt-3(v-if="isScbChannel && !isScb && !isKtb && !isBay && !isUploadSlip")
            div.info-title
              | ❗กรุณาอ่านก่อนทำรายการเติมเงิน❗
            div.mt-2
              ol
                li กรุณาใช้บัญชีธนาคารที่ ผูกไว้กับระบบเท่านั้น
                li เพื่อความรวดเร็วในการตรวจสอบยอด ควรโอนยอดที่ไม่ซ้ำกับครั้งก่อน
                li หลังจากโอน ระบบจะทำการปรับเครดิต ให้อัตโนมัติภายใน 1นาที
                li หากเครดิตไม่เข้าหรือพบปัญหา กรุณา ติดต่อเจ้าหน้าที่ทันที
                li ในกรณีฝากแบบ อัพโหลดสลิป กรุณาอัพโหลดสลิปภายใน 10 นาทีเท่านั้น
            div.red-info.mt-2
              | 🔴 หลีกเลี่ยงการโอนเงินในช่วงเวลา 00:00 น. (เที่ยงคืน) เนื่องจากระบบธนาคารบางแห่งอาจไม่สามารถตรวจสอบยอดได้ในช่วงเวลาดังกล่าว 🔴

          v-card.auto-info.mt-3(v-if="isKtb && !isUploadSlip")
            div.info-title
              img.info-logo.mr-1(src='@/assets/logo/ktb.png' width="20")
              | กรุณาอ่านก่อนทำรายการเติมเงิน
              img.info-logo.ml-1(src='@/assets/logo/ktb.png' width="20")
            div.mt-2
              ol
                li กรุณาใช้บัญชีธนาคารที่ผูกกับระบบเท่านั้น
                li เพื่อความรวดเร็วในการตรวจสอบยอด กรุณาโอนยอดที่ไม่ซ้ำกับครั้งก่อน
                li หลังโอนสำเร็จ ระบบจะเติมเครดิตอัตโนมัติภายใน 1 นาที
                li หากเครดิตไม่เข้า กรุณาติดต่อเจ้าหน้าที่ทันที
                li
                  b สำหรับผู้ที่โอนเข้าธนาคารกรุงไทย (KTB.)
                  img.info-logo.ml-1(src='@/assets/logo/ktb.png' width="20")
            div.mt-2
              | ช่วงเวลา 23:00-02:00 น. ระบบอาจตรวจสอบยอดล่าช้ากว่าปกติ ทำให้เครดิตเข้าช้ากว่าปกติ
            div.red-info.mt-2
              | 🔴 แนะนำหลีกเลี่ยงการโอนผ่านกรุงไทย (KTB.) ในช่วง 23:00–02:00 น. เพื่อความรวดเร็วในการรับเครดิต

          v-card.auto-info.mt-3(v-if="isScb && !isUploadSlip")
            div.info-title
              img.info-logo.mr-1(src='@/assets/bankimg/5.png' width="20")
              | กรุณาอ่านก่อนทำรายการเติมเงิน
              img.info-logo.ml-1(src='@/assets/bankimg/5.png' width="20")
            div.mt-2
              ol
                li กรุณาใช้บัญชีธนาคารที่ผูกกับระบบเท่านั้น
                li เพื่อความรวดเร็วในการตรวจสอบยอด กรุณาโอนยอดที่ไม่ซ้ำกับครั้งก่อน
                li หลังโอนสำเร็จ ระบบจะเติมเครดิตอัตโนมัติภายใน 1 นาที
                li หากเครดิตไม่เข้า กรุณาติดต่อเจ้าหน้าที่ทันที
                li
                  b สำหรับผู้ที่โอนเข้าธนาคารไทยพาณิชย์ (SCB.)
                  img.info-logo.ml-1(src='@/assets/bankimg/5.png' width="20")
            div.mt-2
              | ช่วงเวลา 23:00-01:30 น. ระบบอาจตรวจสอบยอดล่าช้ากว่าปกติ ทำให้เครดิตเข้าช้ากว่าปกติ
            div.red-info.mt-2
              | 🔴 แนะนำหลีกเลี่ยงการโอนผ่านธนาคารไทยพาณิชย์ (SCB.) ในช่วงเวลา 23:00–01:30 น. เพื่อความรวดเร็วในการรับเครดิต 🔴

          v-card.auto-info.mt-3(v-if="isBay && !isUploadSlip")
            div.info-title
              img.info-logo.mr-1(src='@/assets/bankimg/6.png' width="20")
              | กรุณาอ่านก่อนทำรายการเติมเงิน
              img.info-logo.ml-1(src='@/assets/bankimg/6.png' width="20")
            div.mt-2
              ol
                li กรุณาใช้บัญชีธนาคารที่ผูกกับระบบเท่านั้น
                li เพื่อความรวดเร็วในการตรวจสอบยอด กรุณาโอนยอดที่ไม่ซ้ำกับครั้งก่อน
                li หลังโอนสำเร็จ ระบบจะเติมเครดิตอัตโนมัติภายใน 1 นาที
                li หากเครดิตไม่เข้า กรุณาติดต่อเจ้าหน้าที่ทันที
                li
                  b สำหรับผู้ที่โอนเข้าธนาคารกรุงศรีอยุธยา (BAY.)
                  img.info-logo.ml-1(src='@/assets/bankimg/6.png' width="20")
            div.mt-2
              | สามารถทำรายการฝากเงินได้ตลอด 24 ชั่วโมง ระบบเติมเครดิตอัตโนมัติตามปกติ
            div.green-info.mt-2
              | 🟢 ธนาคารกรุงศรีอยุธยา (BAY.) รองรับการฝากเงินตลอด 24 ชั่วโมง เพื่อความสะดวกในการทำรายการ
        v-divider
        v-card-actions
          v-btn(
            block
            dark
            depressed
            color='red'
            @click='closeInfoDialog'
          ) {{ acknowledgeText }}

</template>
<script> 
import { agentBanks as apiAgentBanks, agentInfo as apiAgentInfo  } from '@/apis'
import jsQR from 'jsqr'
import { bankIconPath } from '@/plugins/mapImage' 
import { ROUTE_SETTING } from '@/const/route'

const SCB = 5
const SCB_ANYWHERE = 31
const TTB = 4
const KRUNGSRI_BUSINESS = 32
const KTB_BUSINESS = 34
const TRUE_MONEY = 15
const PAPAYA_PAY = 17
const BITPAY = 23
const KBANK_BUSINESS = 35
const NEXVO = 44
const MATTPAY = 45
const LINK_DEEP_CODE = 46
const NEXVO2 = 47
const READ_INFO_SECONDS = 3

export default {
  props: {
    onSubmitLoading: {
      type : Boolean,
      default : false
    },
  },
  data: () => ({
    agentInfo: {},
    bankList : [],
    selectAmount : undefined,
    bankSelected : undefined,
    bankerrorMessages : undefined,
    amounterrorMessage : undefined,
    limitTopup : 1000000,
    hadData : false,
    submitStatus : false,
    selectedVoucher: null,
    canDisbleInput: false,
    errorMessage: null,
    hasTried: false,
    preview: null,
    request_qr_string: null,
    infoDialog: false,
    readCountdown: 0,
    readTimer: null,
  }),
  computed: {
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    selectTabAmount () {
      const preset = this.bankSelected?.amount_preset
      if (Array.isArray(preset)) return preset
      try { return JSON.parse(preset) } catch (e) { return [] }
    },
    isNormalChannel () {
      return !this.isTrueWalletChannel && !this.isScbChannel
    },
    isTrueWalletChannel () {
      return this.bankSelected?.bank_type?.id == TRUE_MONEY
    },
    isScbChannel () {
      return [SCB,SCB_ANYWHERE,KRUNGSRI_BUSINESS,TTB,KTB_BUSINESS,KBANK_BUSINESS].includes(this.bankSelected?.bank_type?.id)
    },
    isBitpay () {
      return this.bankSelected?.bank_type?.id == BITPAY
    },
    isKtb () {
      return this.bankSelected?.bank_type?.id == KTB_BUSINESS
    },
    isScb () {
      return this.bankSelected?.bank_type?.id == SCB_ANYWHERE
    },
    isBay () {
      return this.bankSelected?.bank_type?.id == KRUNGSRI_BUSINESS
    },
    isNexvo () {
      return this.bankSelected?.bank_type?.id == NEXVO
    },
    isNexvo2 () {
      return this.bankSelected?.bank_type?.id == NEXVO2
    },
    isMattpay () {
      return this.bankSelected?.bank_type?.id == MATTPAY
    },
    isLinkDeepCode () {
      return this.bankSelected?.bank_type?.id == LINK_DEEP_CODE
    },
    isCreateQrCode () {
      return this.isBitpay
    },
    isUploadSlip () {
      return !!this.bankSelected?.is_upload_slip
    },
    hasDepositInfo () {
      if (!this.bankSelected) {
        return false
      }

      if (this.isUploadSlip) {
        return true
      }

      return this.isMattpay || this.isNexvo || this.isNexvo2 || this.isLinkDeepCode || this.isScbChannel || this.isKtb || this.isBay
    },
    acknowledgeText () {
      return this.readCountdown > 0
        ? `รับทราบได้ในอีก ${this.readCountdown} วินาที`
        : 'รับทราบ'
    }
  },
  watch : {
    bankSelected () {
      if(this.bankSelected!==undefined){
        this.bankerrorMessages = ''
        this.openInfoDialog()
      }else {
        this.bankerrorMessages = this.$t('validate.please-select-bank')
      }
    },
    selectAmount () {
      if(this.selectAmount===undefined || this.selectAmount==='' || this.selectAmount===null){
        this.amounterrorMessage = this.$t('validate.please-enter-number')
      } else if (this.bankSelected && !this.isAmountTypeValid()) {
        this.amounterrorMessage = this.amountTypeMessage()
      } else if (!this.isMetCondition()) {
        // this.bankSelected = undefined
      } else {
        if(this.bankSelected&&((this.bankSelected.amount_limit || '').amount_remain||0) < this.selectAmount) {
          // this.bankSelected = undefined
          this.amounterrorMessage = this.$t('validate.over-max-account-amount-deposit')
        }else {
          this.amounterrorMessage = '' 
        }
      }
    },
    bankList () {
      if (this.bankList.length == 1) {
        this.bankSelected = this.bankList[0]
      } else {
        this.bankerrorMessages = this.$t('validate.please-select-bank')
      }
    }
  },
  async created () {
    await this.load()
    await this.loadAgentInfo()
  },
  beforeDestroy () {
    this.clearReadTimer()
  },
  methods : {
    openInfoDialog () {
      if (!this.hasDepositInfo) {
        return
      }

      this.clearReadTimer()
      this.readCountdown = READ_INFO_SECONDS
      this.infoDialog = true

      this.readTimer = setInterval(() => {
        this.readCountdown -= 1

        if (this.readCountdown <= 0) {
          this.clearReadTimer()
        }
      }, 1000)
    },
    closeInfoDialog () {
      if (this.readCountdown > 0) {
        return
      }

      this.infoDialog = false
    },
    clearReadTimer () {
      if (this.readTimer) {
        clearInterval(this.readTimer)
        this.readTimer = null
      }
    },
    async loadAgentInfo (){
      const [err,data ] = await apiAgentInfo.get()
      
      if(err) {
        return
      }     

      this.agentInfo = data 
    },
    bankIconPath, 
    goToLineAgent () {
      const lineId = this.agentInfo.line_id
      const url = `http://line.me/ti/p/~${lineId}`
      window.open(url,'_blank'); 
    },
    async load (params = {}) {

      params.transaction_type_id = 1

      if (this.$route.query.type === "pre-promotion") {
        this.canDisbleInput = true
      } else {
        localStorage.removeItem('selectedVoucher') 
        localStorage.removeItem('currentPurchasedAmount')
      }

      this.selectedVoucher = JSON.parse(localStorage.getItem('selectedVoucher')) || null

      if (this.selectedVoucher && this.canDisbleInput) {
        this.selectAmount = this.selectedVoucher.rules.topup_amount
      }

      this.hadData=false
      const [err,data,,,status] = await apiAgentBanks.get(params)
      this.hadData=true
      
      if(status===400) { 
        this.$emit('nextPage',data)
        return
      }

      if(err) {
        this.$alert('',err,'warning')
        return
      } 
      this.bankList = data   
    },
    bankSubtitle (bank) {
      let subtitle = ''

      if (bank.bank_type.min_deposit) {
        subtitle = `ขั้นต่ำ ${bank.bank_type.min_deposit}`
      }

      if (bank.bank_type.max_deposit) {
        subtitle = `${subtitle} ไม่เกิน ${bank.bank_type.max_deposit}`
      }

      if (subtitle != '') {
        subtitle = `${subtitle} บาท`
      }

      return subtitle
    },
    isAmountTypeValid () {
      const type = Number(this.bankSelected?.amount_type)
      const amount = Number(this.selectAmount)
      if (!amount) return false
      if (type === 2) return Number.isInteger(amount)
      if (type === 3) return Math.round(amount * 100) % 100 !== 0
      return true
    },
    amountTypeMessage () {
      const type = Number(this.bankSelected?.amount_type)
      if (type === 2) return 'กรุณากรอกจำนวนเต็ม (ไม่มีจุดทศนิยม)'
      if (type === 3) return 'กรุณากรอกจำนวนที่มีเศษสตางค์ เช่น 100.50 (ทศนิยมต้องไม่เป็น 0)'
      return ''
    },
    isMetCondition () {

      if (this.selectAmount == undefined || this.bankSelected == undefined ) {
        return false;
      }

      if (!this.isAmountTypeValid()) {
        return false
      }

      if (this.bankSelected.bank_type.min_deposit && this.selectAmount < this.bankSelected.bank_type.min_deposit) {
        return false
      }

      if (this.bankSelected.bank_type.max_deposit && this.selectAmount > this.bankSelected.bank_type.max_deposit) {
        return false
      }

      return true;
    },
    isBankMetCondition (bank) {

      if (this.selectAmount == undefined || this.selectAmount == '') {
        return true;
      }

      if (bank.bank_type.min_deposit && this.selectAmount < bank.bank_type.min_deposit) {
        return false
      }

      if (bank.bank_type.max_deposit && this.selectAmount > bank.bank_type.max_deposit) {
        return false
      }

      return true;
    },    
    GA (action,item){
      this.$ga.event('Button', action, 'DepositPage',item)
    },
    nextPage () {
      
      if (this.userProfile.bank_type === null && this.bankSelected?.bank_type?.id == PAPAYA_PAY) {
        this.$alert('กรุณาตั้งค่าบัญชีธนาคารของท่าน','', 'warning').then(() => {
          this.$router.push({ name: ROUTE_SETTING, query: { tab: 'bank' } }).catch(() => {}); 
        });

        return;
      }

      if(this.selectAmount!==undefined&&this.selectAmount!==''&&this.bankSelected!==undefined&&this.limitTopup>this.selectAmount && this.isMetCondition()){
        this.submitStatus = true 
        this.$emit('submit',this.bankSelected,this.selectAmount, null) 
        this.submitStatus = false
      } else if(this.bankSelected===undefined&&this.selectAmount===undefined&&this.limitTopup>this.selectAmount){
        this.bankerrorMessages = this.$t('validate.please-select-bank') 
        this.amounterrorMessage = ''
      } else if(this.selectAmount===undefined){
        this.amounterrorMessage = this.$t('validate.please-enter-number')
      } else if(this.bankSelected===undefined){
        this.bankerrorMessages = this.$t('validate.please-select-bank') 
      } else if(!this.isMetCondition()) {
        this.amounterrorMessage = `กรุณากรอกจำนวนเงินให้ถูกต้อง`

        if (this.isMattpay) {
          this.amounterrorMessage = `Mattpay ฝากขั้นต่ำ ${this.bankSelected.bank_type.min_deposit}-${this.bankSelected.bank_type.max_deposit || '999,999'} กรุณาระบุจำนวนให้ถูกต้อง`
        }

        if (this.isNexvo) {
          this.amounterrorMessage = `NEXVO ฝากขั้นต่ำ ${this.bankSelected.bank_type.min_deposit}-${this.bankSelected.bank_type.max_deposit || '999,999'} กรุณาระบุจำนวนให้ถูกต้อง`
        }

        if (this.isNexvo2) {
          this.amounterrorMessage = `NEXVO2 ฝากขั้นต่ำ ${this.bankSelected.bank_type.min_deposit}-${this.bankSelected.bank_type.max_deposit || '999,999'} กรุณาระบุจำนวนให้ถูกต้อง`
        }
      } else {
        this.amounterrorMessage = `${this.$t('validate.please-add-credit-not-more')} ${this.limitTopup} ${ this.$t('unit.baht') }`
      }
    },
    async copyText (text) {
      try {
        await navigator.clipboard.writeText(text);
        alert('คัดลอกสำเร็จ');
      } catch($e) {
        alert('ไม่สามารถคัดลอกได้');
      }
    },
    submitQr () { 
      if (!this.request_qr_string) {
        this.hasTried = true
        this.errorMessage = "กรุณาอัปโหลดรูปภาพสลิปโอนเงิน"
        return
      }

      this.$emit('submit', this.bankSelected, null, this.request_qr_string) 
    },
    onFileChange (event) {
      this.request_qr_string = null
      this.errorMessage = ""
      this.preview = null

      const file = event.target.files[0]
      if (!file) return

      this.preview = URL.createObjectURL(file)

      this.readQR(file)
    },

    readQR (selectedFile) {
      this.request_qr_string = null
      this.errorMessage = ""

      if (!selectedFile) return

      this.hasTried = true

      const imageFile = Array.isArray(selectedFile)
        ? selectedFile[0]
        : selectedFile

      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result

        img.onload = () => {
          const canvas = this.$refs.canvas
          const ctx = canvas.getContext("2d", { willReadFrequently: true })
          
          const MAX_WIDTH = 800

          const scale = Math.min(MAX_WIDTH / img.width, 1)
          canvas.width = img.width * scale
          canvas.height = img.height * scale

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

          const imageData = ctx.getImageData(
            0,
            0,
            canvas.width,
            canvas.height
          )

          const code = jsQR(
            imageData.data,
            imageData.width,
            imageData.height
          )

          if (code) {
            this.request_qr_string = code.data
          } else {
            this.errorMessage = "ไม่พบ QR Code ในรูปภาพนี้"
          }
        }
        img.onerror = () => {
          this.errorMessage = "ไฟล์รูปภาพไม่ถูกต้อง หรือไม่สามารถอ่านได้"
        }
      }

      reader.readAsDataURL(imageFile)
    },
  }
}
</script>
<style scoped>
.qr-img >>> .v-responsive__content {
  width: unset !important;
}

.f-col {
  flex-direction: column;
}

.f-start {
  align-items: flex-start;
}

.subtitle {
  font-size: 10px;
}

.auto-info {
  padding: 1rem;
  font-size: 0.875rem;
  font-weight: bold;
  box-shadow: unset !important;
  border: 0.5px solid black;
  border-radius: 5px;
}

.red-info {
  color: red;
}

.green-info {
  color: green;
}

.text-info {
  font-size: 0.975rem;
}

.btn-bank {
  background-color: var(--bg-secondary-color);
}

.info-title {
  font-weight: bold;
  color: red;
  text-align: center;
  line-height: 3rem;
  font-size: 1.1256rem;
  width: fit-content;
  margin: 0 auto;
}

.info-logo {
  vertical-align: middle;
  display: inline-block;
}

@media only screen and (max-width: 380px) {
  .info-title {
    font-size: 0.925rem;
  }
}

.rainbow-box {
  border: 3px solid transparent;
  border-radius: 12px;

  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(to bottom right,
      #b827fc 0%,
      #2c90fc 25%,
      #b8fd33 50%,
      #fec837 75%,
      #fd1892 100%
    ) border-box;
}

.onetime-title {
  text-align: center;
  color: red;
  font-size: 0.925rem;
}

.bank-logo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}

.bank-logo-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}

.input-fill-amount >>> .v-messages__message {
  font-size: 0.875rem;
  margin-top: 6px;
  margin-bottom: 4px;
}
</style>
